var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('div',{staticClass:"alert alert-secondary"},[_vm._v(" Création en cours ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }